import * as toastr from "toastr";
import { Or } from "source/app/domain/Or";
import { Sounds } from "../../services/Sound/Sounds";

export const HandleError = (e: any) => {
    DisplayToastrError(e, "Whoops", { timeOut: 500 });
};

export function DisplayToastrError(
    message: string,
    title: string,
    options?: ToastrOptions
) {
    Sounds.grunt.Play({ allowConcurrent: false, volume: 0.25 });
    const toastrOptions = Or(options, {});
    toastr.error(message, title, toastrOptions);
}
